export default "__VITE_ASSET__B9oHS8K___"